import FormLogin from './FormLogin.vue'
import FormConfirmEmail from './FormConfirmEmail.vue'
import FormResetPassword from './FormResetPassword.vue'


export { FormLogin, FormConfirmEmail, FormResetPassword }